import type { SiteContent } from "../siteData";
import { SocialIcon } from "./SocialIcon";

type SocialLinksProps = {
  links: SiteContent["socialLinks"];
};

export function SocialLinks({ links }: SocialLinksProps) {
  return (
    <section className="section section--charcoal section--compact" aria-label="Social media links">
      <div className="container">
        <div className="socialLinks">
          {links.map(link => (
            <a
              className="socialLinks__link"
              key={link.href}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.label}
            >
              <SocialIcon name={link.icon} />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
